import { nanoid } from "nanoid";
// import { decrypt } from "./encryption";
import { getClient } from "./http";

export const getFirstName = (name: string) => {
  return name.split(" ")[0];
};

export const handleLogin = async (
  response: any,
  setUserDetails: any,
  source?: string,
  setSource?: any,
) => {
  const encryptedData = response?.data?.data;
  // const decryptedData = JSON.parse(decrypt(encryptedData));
  const decryptedData = encryptedData;
  // sessionStorage.setItem("userDetails", encryptedData);
  sessionStorage.setItem("userDetails", JSON.stringify(encryptedData));
  source && localStorage.setItem("source", source);
  setUserDetails({ ...decryptedData });
  setSource && setSource(source);

  //set apigee access token
  // if (
  //   ["wc-claims", "tech-eo", "tech-do"].some((value) =>
  //     decryptedData?.scopes?.includes(value),
  //   )
  // ) {
  //   const data = new URLSearchParams();
  //   data.append("grant_type", process.env.REACT_APP_APIGEE_GRANT_TYPE || "");
  //   data.append("client_id", process.env.REACT_APP_APIGEE_CLIENT_ID || "");
  //   data.append(
  //     "client_secret",
  //     process.env.REACT_APP_APIGEE_CLIENT_SECRET || "",
  //   );
  //   const apigeeToken = await getClient("apigee").post(
  //     "/api/v1/auth/token",
  //     data,
  //     {
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //       },
  //     },
  //   );
  //   apigeeToken &&
  //     localStorage.setItem("apigeeToken", apigeeToken?.data?.access_token);
  // }
};

export const capitalize = (str: string) => {
  if (!str) return "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const roundOff = (num: number, roundOffDigit: number = 2) => {
  return typeof num == "number" && !Number.isInteger(num)
    ? Number(num.toFixed(2))
    : num;
};

export const sanitizeUserInputQuery = (input: string) => {
  return input
    .replace(/db\.\w+\.\w+\(.*?\)/gi, "")
    .replace(/db\.\w+\(\)/gi, "")
    .replace(
      /(\{\s*)?\$\w+\s*:\s*(\{[^}]*\}|\d+|".*?"|'.*?'|`.*?`|‘.*?‘)(\s*\})?/gi,
      "",
    );
};

export const validateEmail = (email: string) => {
  const reg: RegExp =
    /^([A-Za-z0-9_\-\\.])+@([A-Za-z0-9_\-\\.])+\.([A-Za-z]{2,4})$/;
  return reg.test(email);
};

export const getNewChat = () => {
  return { sessionId: nanoid(), title: "New chat", conversations: [] };
};

// Helper to convert Title Case from Sanke Case
export function toTitleCaseFromSnake(input: string): string {
  return input
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

// Helper: safely stringify any cell for a Markdown table
const stringifyCell = (value: any): string => {
  if (value === null || value === undefined) return "";

  // strings: preserve markdown like **bold**, escape pipes, convert newlines to <br>
  if (typeof value === "string") {
    return value.replace(/\|/g, "\\|").replace(/\r\n|\r|\n/g, "<br>");
  }

  // arrays: render as HTML list for reliable bullets inside table cells
  if (Array.isArray(value)) {
    const items = value.map((v) => {
      // convert nested items to string safely
      const text =
        typeof v === "string"
          ? v
          : typeof v === "object"
            ? JSON.stringify(v)
            : String(v);
      // escape pipes and convert internal newlines
      const safe = text.replace(/\|/g, "\\|").replace(/\r\n|\r|\n/g, "<br>");
      return `${safe}<br>`;
    });
    return `${items.join("")}`;
  }

  // primitives
  if (typeof value !== "object") {
    return String(value).replace(/\|/g, "\\|");
  }

  // objects: compact JSON
  try {
    const json = JSON.stringify(value, null, 2);
    return json.replace(/\|/g, "\\|").replace(/\r\n|\r|\n/g, "<br>");
  } catch {
    return String(value).replace(/\|/g, "\\|");
  }
};

const collectHeaders = (rows: Record<string, any>[]) => {
  const seen = new Set<string>();
  rows.forEach((row) => Object.keys(row).forEach((k) => seen.add(k)));
  return Array.from(seen);
};

// Main function: array of objects or single object supported
export const jsonToTableMarkdown = (data: any): string => {
  const rowsArray: Record<string, any>[] = Array.isArray(data)
    ? data
    : data && typeof data === "object"
      ? [data]
      : [];

  if (rowsArray.length === 0) return "_No data_";

  const headers = collectHeaders(rowsArray);
  const headerLine = `| ${headers.join(" | ")} |`;
  const separatorLine = `| ${headers.map(() => "---").join(" | ")} |`;
  const rowLines = rowsArray.map((row) => {
    const cells = headers.map((h) => stringifyCell(row[h]));
    return `| ${cells.join(" | ")} |`;
  });

  return [headerLine, separatorLine, ...rowLines].join("\n");
};

export const encodeBase64 = (str: string) => {
  const bytes = new TextEncoder().encode(str);
  const binary = bytes.reduce(
    (acc, byte) => acc + String.fromCharCode(byte),
    "",
  );
  return btoa(binary);
};

export const decodeBase64 = (str: string) => {
  const bytes = Uint8Array.from(atob(str), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

export const strToArrayBuffer = (str: string) =>
  new TextEncoder().encode(str);

export const base64ToArrayBuffer = (base64: string) =>
  Uint8Array.from(atob(base64), c => c.charCodeAt(0));

export const arrayBufferToBase64 = (input: ArrayBuffer | Uint8Array) => {
  let buffer: Uint8Array;

  if (input instanceof Uint8Array) {
    buffer = input;
  } else {
    buffer = new Uint8Array(input);
  }

  let binary = "";
  for (let i = 0; i < buffer.length; i++) {
    binary += String.fromCharCode(buffer[i]);
  }

  return btoa(binary);
};

export const toArrayBuffer = (data: Uint8Array): ArrayBuffer => {
  return Uint8Array.from(data).buffer;
};



